/** @jsx jsx */

import React, { useEffect, useRef, useState } from "react";
import { jsx, css } from "@emotion/react";
import { chunkSizeCalculation, initUpload, getPressignedUrl, defineChunkSizeArray, finalizeUpload, continueUploadAxios } from "../helpers/utils";
import { CircularProgress, Paper, Table, TableBody, TableCell, TableHead, TableRow } from "@material-ui/core";
import { makeStyles } from '@material-ui/core/styles';

const onePadding = css`
  padding-top:1em;
  padding-bottom:1em;
`;

const topBottomPadding = css`
  padding-top:1em;
  padding-bottom:1em;
`;

const progressSpan = css`
    position:absolute;
    top:10px;
    left:2px;
`;

interface ProgressProps {
    originalFileName: string,
    fileSize: number,
    fileType: string,
    uploadPath: string,
    file: any,
    s3Key: string,
    onCompleteHandler: (e: string) => void;
}

const useStyles = makeStyles(theme => ({
    root: {
        width: '50%',
        overflowX: 'auto'
    },
    table: {
        minWidth: 200
    },
    tablecell: {
        fontSize: '10pt'
    }
}));



const Progress: React.FC<ProgressProps> = ({ originalFileName, fileSize, fileType, uploadPath, file, s3Key, onCompleteHandler }) => {

    const [progressRate, setProgressRate] = useState<string>("0.0");
    const [progressLabel, setProgressLabel] = useState<string>("");
    const [circularProgressValue, setCircularProgressValue] = useState<string>("visible");

    const cirCss = css`
        visibility: ${circularProgressValue}
    `;// NB cannot use 'style' with visibility & var on CircularProgress . TS bug ?

    const optimalChunkSizeInBytes = chunkSizeCalculation(fileSize);
    const n = Math.ceil((fileSize) / optimalChunkSizeInBytes);
    const size: number = fileSize;

    const onCompleted = (eventValue: string) => {
        onCompleteHandler(eventValue)
    };

    const classes = useStyles();

    const displayError = () => {
        setProgressLabel("失敗");
        setCircularProgressValue("hidden");
    };

    useEffect(() => {

        const chunkSizeArray: Array<object> = defineChunkSizeArray(n, size, optimalChunkSizeInBytes)
        console.log(chunkSizeArray);
        (async () => {
            // Init upload
            const initRes: any = await initUpload({
                fileSize: fileSize,
                s3Key: s3Key,
                fileType: fileType
            });
            // Continue upload // NB parts are sent one by one in the correct order
            var uploadedData = 0;
            for (const ele of chunkSizeArray) {
                console.log("[DEBUG] Uploading part number : " + ele["part"]);
                const ctnRes: any = await getPressignedUrl({
                    s3Key: s3Key,
                    partNumber: ele["part"],
                    uploadId: initRes.upload_id
                });
                setProgressLabel("アップロード中");
                const blob = new Blob([file], { type: fileType });
                const chunk = blob.slice(ele['startByte'], ele['endByte']);
                const config = {
                    onUploadProgress: (e: any) => {
                        const event = e;
                        if (event.loaded == event.total) {
                            console.log("Chunk uploaded");
                            uploadedData += (event.total);
                        } else {
                            const percentage: string = (((uploadedData + event.loaded) / (fileSize)) * 100).toFixed(1);
                            setProgressRate(percentage);
                        }
                    },
                    withCredentials: false,
                    headers: { 'content-type': 'application/octet-stream' },
                };
                const preSignedUrlResCode: any = await continueUploadAxios({
                    chunk: chunk,
                    presignedUrl: ctnRes.pre_signed_url,
                    config: config
                });

                // Upload progree UI
                if (preSignedUrlResCode == 200) {
                    // ok, continue
                } else {
                    displayError();
                }

                // Detecting the final part
                if (parseInt(ele["part"]) == (n) && preSignedUrlResCode == 200) {
                    // Finalize upload
                    const finalizeUploadRes: any = await finalizeUpload({
                        s3Key: s3Key,
                        uploadID: initRes.upload_id
                    });
                    if (finalizeUploadRes.status == 200) {
                        setProgressRate("100");
                        setProgressLabel("成功");
                        onCompleted(finalizeUploadRes.data.message.signed_video_url);
                        setCircularProgressValue("hidden");
                    } else {
                        displayError();
                    }
                }
            }
        })();
    }, []); // NB UseEffect called only once

    return (
        <div css={topBottomPadding} >
            <h3 css={onePadding}>3.アップロード情報</h3>
            <Paper className={classes.root}>
                <Table className={classes.table} >
                    <TableHead></TableHead>
                    <TableBody>
                        <TableRow>
                            <TableCell className={classes.tablecell} align="left">ファイル名</TableCell>
                            <TableCell className={classes.tablecell} align="left">{originalFileName}</TableCell>
                        </TableRow>
                        <TableRow >
                            <TableCell className={classes.tablecell} align="left">アップロードパス</TableCell>
                            <TableCell className={classes.tablecell} align="left">{uploadPath}</TableCell>
                        </TableRow>
                        <TableRow >
                            <TableCell className={classes.tablecell} align="left">ファイルサイズ</TableCell>
                            <TableCell className={classes.tablecell} align="left">{fileSize} bytes | {(fileSize / (1024 ** 3)).toFixed(1)} GB</TableCell>
                        </TableRow>
                        <TableRow >
                            <TableCell className={classes.tablecell} align="left">進捗</TableCell>
                            <TableCell className={classes.tablecell} align="left">
                                <div style={{ position: 'relative' }}>
                                    <span css={progressSpan}>{progressRate}%</span>
                                    <CircularProgress css={cirCss} />
                                </div></TableCell>
                        </TableRow>
                        <TableRow >
                            <TableCell className={classes.tablecell} align="left">ステータス</TableCell>
                            <TableCell className={classes.tablecell} align="left">{progressLabel}</TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Paper>
        </div>
    );
};

export default Progress;

